// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_3Pt","cls2":"SingularMentionCitationModal-cls2_o-G SingularMentionCitationModal-cls1_3Pt"};